(() => {
  const localHosts = new Set(['127.0.0.1', 'localhost']);
  if (!localHosts.has(window.location.hostname)) return;

  const countryCode = 'IN';
  const currentUrl = new URL(window.location.href);
  const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href;
  const storefrontOrigin = canonicalUrl ? new URL(canonicalUrl).origin : null;
  if (currentUrl.searchParams.get('country') !== countryCode) {
    currentUrl.searchParams.set('country', countryCode);
    window.location.replace(currentUrl.toString());
    return;
  }

  const localizeUrl = (value) => {
    if (!value || value.startsWith('#')) return null;
    const url = new URL(value, window.location.href);
    if (url.origin !== window.location.origin) return null;
    url.searchParams.set('country', countryCode);

    // Shopify's new customer-account OAuth endpoint rejects the temporary
    // bearer token used by the HTTP localhost theme proxy. Send only account
    // authentication routes through the store's HTTPS domain; their existing
    // return_to parameter brings the customer back to the matching live page.
    if (url.pathname.startsWith('/customer_authentication/') && storefrontOrigin) {
      return `${storefrontOrigin}${url.pathname}${url.search}${url.hash}`;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  };

  const localizeNavigation = (root) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const localized = localizeUrl(link.getAttribute('href'));
      if (localized) link.setAttribute('href', localized);
    });
    root.querySelectorAll('form[action]').forEach((form) => {
      const localized = localizeUrl(form.getAttribute('action'));
      if (localized) form.setAttribute('action', localized);
    });
  };

  const start = () => {
    localizeNavigation(document);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) localizeNavigation(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
